import http from "../services/customAxios";
import SoapDoRefreshTablesCommand from "../soap/SoapDoRefreshTablesCommand";
import SoapDoUpdateCommand from "../soap/SoapDoUpdateCommand";

// let url = "http://localhost:8080/cash/Authentication";
// let url = "https://wildfly.orbit.local/cash/Authentication";
// let url = `https://dev.ots13.com:443/cash/Authentication`;

export default {
  async processCommandXML(commandXML, calledFrom = "NOT SET") {
    try {
      console.log("CALLED FROM:", calledFrom);
    } catch (error) {
      console.log(error);
    }
    console.log("commandXML:", commandXML);
    let resp = await http.post("/cash/RunDBCommand", commandXML, {
      crossDomain: true,
      headers: {},
    });
    return resp;
  },

  async doGetCashPositionOpeningBalances(accountId, startDate = null, daysOut = 7) {
    let soapDUC = new SoapDoUpdateCommand();
    soapDUC.buildGetCashPositionOpeningBalances(accountId, startDate, daysOut);
    let doGetCashPositionOpeningBalancesXML = soapDUC.generateMessage();

    return this.processCommandXML(
      doGetCashPositionOpeningBalancesXML,
      "doGetCashPositionOpeningBalances"
    );
  },

  async doGetCashPositionActivity(accountId, clientId, startDate = null, daysOut = 7) {
    let soapDUC = new SoapDoUpdateCommand();
    soapDUC.buildGetCashPositionActivity(accountId, clientId, startDate, daysOut);
    let doGetCashPositionActivityXML = soapDUC.generateMessage();

    return this.processCommandXML(doGetCashPositionActivityXML, "doGetCashPositionActivity");
  },

  async doGetPaymentsForClient(clientID, startDate = null, endDate = null) {
    let soapDUC = new SoapDoUpdateCommand();
    soapDUC.buildGetPaymentsForClient(clientID, startDate, endDate);
    let doGetPaymentsForClientXML = soapDUC.generateMessage();

    return this.processCommandXML(doGetPaymentsForClientXML, "doGetPaymentsForClient");
  },

  async doReleasePayment(paymentId, userName) {
    let soapDUC = new SoapDoUpdateCommand();
    soapDUC.buildReleasePaymentForClient(paymentId, userName);
    let doReleasePaymentForClientXML = soapDUC.generateMessage();

    return this.processCommandXML(doReleasePaymentForClientXML, "doReleasePayment");
  },
  async doGetLedgerEntries(accountId, ledgerTag, forDate = null) {
    let soapDUC = new SoapDoUpdateCommand();
    soapDUC.buildGetLedgerEntriesForAccount(accountId, ledgerTag, forDate);
    let doGetLedgerEntriesXML = soapDUC.generateMessage();

    return this.processCommandXML(doGetLedgerEntriesXML, "doGetLedgerEntries");
  },

  async doGetBankDetails(accountId, forDate = null) {
    let soapDUC = new SoapDoUpdateCommand();
    soapDUC.buildGetBankDetailsForAccount(accountId, forDate);
    let doGetBankDetailsXML = soapDUC.generateMessage();

    return this.processCommandXML(doGetBankDetailsXML, "doGetBankDetails");
  },

  async doGetWorksheetDetailsForTransaction(ledgerRID) {
    let soapDUC = new SoapDoUpdateCommand();
    soapDUC.buildGetWorksheetDetailsForTransaction(legerRID);
    let doGetWorksheetDetailsXML = soapDUC.generateMessage();

    return this.processCommandXML(doGetWorksheetDetailsXML, "doGetWorksheetDetailsForTransaction");
  },

  async doGetWorksheetDetailsForMultipleTransactions(ledgerRIDArray) {
    let soapDUC = new SoapDoUpdateCommand();
    soapDUC.buildGetWorksheetDetailsForMultipleTransactions(ledgerRIDArray);
    let doGetWorksheetDetailsXML = soapDUC.generateMessage();

    return this.processCommandXML(
      doGetWorksheetDetailsXML,
      "doGetWorksheetDetailsForMultipleTransactions"
    );
  },

  async doRefreshTables(clientId, accountId) {
    let soapDRT = new SoapDoRefreshTablesCommand();
    soapDRT.buildStandardRefreshCommand(clientId, accountId);
    let doRefreshTablesXML = soapDRT.generateMessage();

    return this.processCommandXML(doRefreshTablesXML, "doRefreshTables");
  },

  async doDashboardAccountSummaryCommand(accountIds, forDate) {
    let soapDUC = new SoapDoUpdateCommand();
    soapDUC.buildStandardDashboardAccountSummaryCommand(accountIds, forDate);
    let doDashboardAccountSummaryXML = soapDUC.generateMessage();

    return this.processCommandXML(doDashboardAccountSummaryXML, "doDashboardAccountSummaryCommand");
  },
};
